import { useCallback } from 'react';

import useDefaultErrorSnackbar from '../useDefaultErrorSnackbar';

interface HandleResponseProps {
  condition: boolean;
  onSuccess: () => void;
  onError?: () => void;
}

const useResponse = () => {
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();

  const handleResponse = useCallback(
    ({ condition, onSuccess, onError = showDefaultErrorSnackbar }: HandleResponseProps) =>
      condition ? onSuccess() : onError(),
    [showDefaultErrorSnackbar],
  );

  return { handleResponse };
};

export default useResponse;
